/* eslint-disable react-hooks/exhaustive-deps */
import App from '../../layout/App';
import React, { useContext, useEffect, useState } from 'react';
import { FormContent, Container } from '../../styles/styles'
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import './styles.css'

import Loading from '../../Components/Loading'
import iconeAluno from "../../assets/iconesMenu/icone-aluno.svg"
import { createBrowserHistory } from "history";
import MessageTitle from '../../Components/MessageTitle';
import InputSearch from '../../Components/InputSearch';
import CardPessoa from '../../Components/CardPessoa';
import InfoPage from '../../Components/infoPage';
import { MessageContext } from '../../context/message';
import PaginationC from '../../Components/pagination';
import { PaginationContext } from '../../context/paginationController';

const inep = sessionStorage.getItem('inep')
let filter = sessionStorage.getItem('filter')
function PesquisarAluno({ props }) {
    const { setErrorMessage } = useContext(MessageContext);
    const { pagination, setPagination } = useContext(PaginationContext);
    let history = createBrowserHistory();
    const [removeLoading, setRemoveLoading] = useState(false)
    const navigation = useNavigate()
    const [filtersSelect, setFiltersSelect] = useState(0)
    const [aux, setAux] = useState([]);
    const [todos, setTodos] = useState([]);
    const [dataSchool, setDataSchool] = useState('')
    const [registerWasChanged, setRegisterWasChanged] = useState(0)

    const [configPagination, setConfigPagination] = useState({
        'currentPage': pagination.currentPage,
        'totalView': pagination.totalView,
        'totalPages': 0
    })
    async function getStudent() {
        setRemoveLoading(false)
        api.get(`/student/list/?inep=${inep}&page=${configPagination.currentPage}&view=${configPagination.totalView}&total=10`
        ).then(response => {
            setRegisterWasChanged(response.data?.registerWasChanged)
            setTodos(response.data?.people)
            setAux(response.data?.people)
            setConfigPagination({
                ...configPagination,
                totalPages: response.data.totalPages,
            })
            setPagination({
                'currentPage': response.data.currentPage,
                'totalView': configPagination.totalView
            })
            setRemoveLoading(true)
        }).catch((err) => {
            setErrorMessage([{ message: "erro ao buscar aluno!", ok: false }])
            setRemoveLoading(true)
        })
    }
    useEffect(() => {

        let data = JSON.parse(localStorage.getItem('dataSchool'))
        setDataSchool(data)
        getStudent()
    }, [])

    useEffect(() => {
        filters(Number(filter))
    }, [todos])

    useEffect(() => {

        const handleBlockBack = () => {
            if (history.action === 'POP') {
                history.go(1); // Impede a ação de voltar do navegador
            }
        };

        window.addEventListener('popstate', handleBlockBack);

        return () => {
            window.removeEventListener('popstate', handleBlockBack);
        };
    }, [history]);

    function filterItems(busca) {
        let Filtrados = []

        busca = busca.toUpperCase()
        if (filtersSelect !== 0) {
            Filtrados = todos.filter((aluno) => aluno.completeName.includes(busca) && aluno.wasChanged === filtersSelect)
        }
        else {
            Filtrados = todos.filter((aluno) => aluno.completeName.includes(busca))

        }
        setAux(Filtrados)
    }

    const EditAluno = (code) => {
        sessionStorage.setItem('AlunoSelecionado', code)
        navigation('/aluno/editar-identificacao')
    }

    function filters(tipo) {
        sessionStorage.setItem('filter', tipo)
        setFiltersSelect(tipo)
        let list = []
        if (tipo === 1) {
            list = todos.filter((aluno) => aluno.wasChanged === true)
        }
        if (tipo === 2) {
            list = todos.filter((aluno) => aluno.wasChanged === false)
        }
        if (tipo === 0) {
            list = todos
        }
        setAux(list)


    }

    const changeCurrentPage = (numPage) => {
        setConfigPagination({ ...configPagination, currentPage: numPage });
        //fetch a data
        //or update a query to get data
    };
    useEffect(() => {
        getStudent()
    }, [configPagination.currentPage, configPagination.totalView])

    return (
        <>
            {!removeLoading && <Loading />}
            <App>
                <Container>
                    <InfoPage
                        img={iconeAluno}
                        title={'ALUNOS'}
                        key={"al7587"}
                        edited={registerWasChanged}
                        notEdited={dataSchool.theAmountStudents - registerWasChanged}
                    />
                    <FormContent style={{ backgroundColor: 'transparent', border: 'none', width: '100%', display: 'flex' }}>
                        <InputSearch
                            valueInput={e => filterItems(e.target.value)}
                            all={(e) => filters(0)}
                            edited={(e) => filters(1)}
                            notEdited={(e) => filters(2)}
                            totalNumber={`Número de alunos: ${dataSchool.theAmountStudents}`}
                            checked={filtersSelect}
                        />

                        <div className='box-card'>
                            {
                               !Array.isArray(aux) || aux?.length === 0 ? <MessageTitle message={'Nenhum Dado encontrado'} /> : aux.map((item, index) => {
                                    return (
                                        <CardPessoa
                                            key={`${item.codePersonSystem}+${item.name}`}
                                            name={item.completeName}
                                            wasChanged={item.wasChanged}
                                            onClick={() => EditAluno(item.codePersonSystem)}
                                        />

                                    )
                                })
                            }
                        </div>
                        <PaginationC
                            currentPage={configPagination.currentPage}
                            totalPages={configPagination.totalPages}
                            defaultView={configPagination.totalView}
                            onChangeView={(e) => { setConfigPagination({ ...configPagination, totalView: Number(e.target.value) }) }}
                            changeCurrentPage={(numPage) => changeCurrentPage(numPage)}
                        />
                    </FormContent>
                </Container>
            </App>
        </>
    )
}
export default PesquisarAluno;